import { formatLineBatchDate } from '@shared/utils/formatLineBatchDate';
import React from 'react';
import { getDisplayableStockBatchLabel, type LocationStockBatchEntry } from '../../models/Location';

export interface LocationBatchBadgeProps {
  /** Solo montar este componente cuando exista un lote; evita celdas/contenedores vacíos */
  batch: LocationStockBatchEntry;
  className?: string;
}

/**
 * Bloque de lote (número + caducidad). Si no hay etiqueta válida (p. ej. batch_id null), no renderiza nada.
 */
export const LocationBatchBadge: React.FC<LocationBatchBadgeProps> = ({ batch, className = '' }) => {
  const batchNumber = getDisplayableStockBatchLabel(batch);
  if (batchNumber == null) return null;

  const expiry = batch.batch?.expiry_date;
  const expiryLabel = expiry ? formatLineBatchDate(expiry) : '';
  const fullLabel = expiryLabel ? `${batchNumber} · Cad. ${expiryLabel}` : batchNumber;

  return (
    <div
      className={`text-xs bg-muted/60 border border-border rounded-md px-2 py-1 inline-flex w-max max-w-none flex-nowrap items-center gap-x-1.5 whitespace-nowrap ${className}`}
      title={fullLabel}
    >
      <span className="font-medium text-foreground">{batchNumber}</span>
      {expiryLabel ? <span className="text-muted-foreground">Cad. {expiryLabel}</span> : null}
    </div>
  );
};
